<form class="comment-edit" (ngSubmit)="onSubmit()">
  @if (requireReason()) {
    <label class="comment-edit__reason-label" [for]="reasonId">
      {{ 'COMMENTS.EDIT.MODERATOR_REASON_LABEL' | translate }}
    </label>
    <input
      pInputText
      #reasonEl
      [id]="reasonId"
      class="comment-edit__reason"
      type="text"
      [placeholder]="'COMMENTS.EDIT.MODERATOR_REASON_PLACEHOLDER' | translate"
      [ngModel]="editReason()"
      (ngModelChange)="editReason.set($event)"
      name="editReason"
      [attr.aria-invalid]="isReasonMissing() ? 'true' : null"
      [attr.aria-describedby]="isReasonMissing() ? reasonId + '-error' : null"
      required>
    @if (isReasonMissing()) {
      <small [id]="reasonId + '-error'" class="comment-edit__error">
        {{ 'COMMENTS.EDIT.MODERATOR_REASON_REQUIRED' | translate }}
      </small>
    }
  }

  @if (uploadErrorMessageKey(); as messageKey) {
    <div
      class="comment-edit__upload-banner"
      role="alert">
      <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      <span>{{ messageKey | translate }}</span>
      <button
        type="button"
        class="comment-edit__upload-banner-dismiss"
        [attr.aria-label]="'GENERAL.DISMISS' | translate"
        (click)="dismissUploadError()">
        <span class="sr-only">{{ 'GENERAL.DISMISS' | translate }}</span>
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
    </div>
  }

  <tf-rich-editor
    [bodyMarkdown]="body()"
    [initialAttachments]="allAttachments()"
    (bodyMarkdownChange)="body.set($event)"
    (attachmentIdsChange)="attachmentIds.set($event)"
    (submitShortcut)="onSubmit()"
    (uploadError)="onUploadError($event)"
    (pendingRemoved)="onPendingRemoved($event)"
    [autofocus]="!requireReason()"
    [ariaLabel]="'COMMENTS.EDIT.BODY_LABEL' | translate" />

  <div class="comment-edit__footer">
    <span
      class="comment-edit__counter"
      [class.comment-edit__counter--over]="isOverLimit()"
      aria-live="polite">
      {{ remaining() }}
    </span>

    <div class="comment-edit__actions">
      <p-button
        type="button"
        [label]="'GENERAL.CANCEL' | translate"
        severity="secondary"
        [text]="true"
        size="small"
        [disabled]="submitting()"
        (onClick)="onCancel()" />
      <p-button
        type="submit"
        [label]="'COMMENTS.EDIT.SAVE' | translate"
        icon="pi pi-check"
        size="small"
        [loading]="submitting()"
        [disabled]="!canSubmit()" />
    </div>
  </div>
</form>
